// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import errorAlertIcon from '../../assets/icons/ic-error-white.svg';
import defaultAlertIcon from '../../assets/icons/checkmark.svg';
import { getRouteTFunction } from '../../i18n';

type Props = {
  text?: string,
  icon?: string,
  iconAltText?: string,
  type: string,
  onClose?: (evt: Event) => void,
  children: any
}
const defaultProps = {
  text: '',
  icon: null,
  iconAltText: '',
  onClose: null
};

const Banner = ({ text, children, icon, iconAltText, type, onClose } : Props) => {
  let msgIcon = icon;
  if (!icon) {
    if (type === 'danger') {
      msgIcon = errorAlertIcon;
    } else {
      msgIcon = defaultAlertIcon;
    }
  }
  return (
    <div className={`alert-banner ${type}`}>
      <img src={msgIcon} alt={iconAltText || 'alert'} />
      <div className='text'>{text || children }</div>
      {onClose ? <span className='delete' onClick={onClose} role='button' tabIndex={0} /> : ''}
    </div>
  );
};
Banner.defaultProps = defaultProps;


const AppBanner = ({ type, children } : Props) => {
  const { t } = useTranslation('alertBanner');
  const routesTFunction = getRouteTFunction();

  const userIdentity = routesTFunction('redirectPaths./user/identity');
  if (type === 'legacy_unverified') {
    return (
      <Banner
        type='danger'
      >
        {[t('verify_your_identity_1'),
          <Link to={userIdentity} className='is-normal'>{t('verify_your_identity_2')}</Link>,
          t('verify_your_identity_3')
        ]}
      </Banner>
    );
  } else if (type === 'await_verification') {
    return (
      <Banner
        type='await'
      >
        {t('thanks_for_submitting')}
      </Banner>
    );
  } else if (type === 'id_rejected') {
    return (
      <Banner
        type='danger'
      >
        {[
          t('resubmit_verification_1'),
          <Link to={userIdentity} className='is-normal'>{t('resubmit_verification_2')}</Link>
        ]}
      </Banner>
    );
  } else if (type === 'alert') {
    return (
      <Banner type='await'>
        {children}
      </Banner>
    );
  }
  return <div />;
};


AppBanner.defaultProps = defaultProps;
export default AppBanner;



// WEBPACK FOOTER //
// ./src/components/shared/AlertBanner.js